import React from "react";
import style from "./IO.module.scss";
import * as ItemUI from "./Item";
import { IOType, IOMode } from "./types";

export default class InlineDetail extends React.Component {
  render() {
    const { io } = this.props;

    return (
      <div className={style.detail}>
        <span>{ItemUI.IOType(io.IOType)}</span>{" "}
        {io.IOMode == IOMode.MultipleAssets || (io.IOType == IOType.Transfer && io.items.length > 1) ? (
          <span className={style.bold}>{"{Multiple securities}"}</span>
        ) : (
          ItemUI.Symbol(io.items[0])
        )}{" "}
        {ItemUI.Account(io)} {ItemUI.BankAccount(io)}
      </div>
    );
  }
}
